import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { useAuth } from '../../../hooks/useAuth';
import { Select, Button, Table, Card, Row, Col, Typography } from 'antd';
import PrintButton from '../../../components/admin/PrintButton';

const { Option } = Select;
const { Title } = Typography;

const ArticlesReport = () => {
  const [articles, setArticles] = useState([]);
  const [users, setUsers] = useState([]);
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    sectionId: null,
    userId: null,
  });
  const { token } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, sectionsRes] = await Promise.all([
          api.get('/api/users', { headers: { Authorization: `Bearer ${token}` } }),
          api.get('/api/sections', { headers: { Authorization: `Bearer ${token}` } })
        ]);
        setUsers(usersRes.data);
        setSections(sectionsRes.data);
      } catch (error) {
        console.error('Failed to fetch users or sections', error);
      }
    };
    if (token) {
      fetchData();
    }
  }, [token]);

  const fetchArticles = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filters.sectionId) {
        params.sectionId = filters.sectionId;
      }
      if (filters.userId) {
        params.userId = filters.userId;
      }
      const response = await api.get('/api/articles', {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setArticles(response.data);
    } catch (error) {
      console.error('Failed to fetch articles', error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    fetchArticles();
  };

  useEffect(() => {
    fetchArticles();
  }, [token]);

  const columns = [
    { title: 'العنوان', dataIndex: 'title', key: 'title' },
    { title: 'المؤلف', dataIndex: ['User', 'username'], key: 'author' },
    { title: 'القسم', dataIndex: ['Section', 'name'], key: 'section' },
    {
      title: 'تاريخ النشر',
      dataIndex: 'publishDate',
      key: 'publishDate',
      render: (date) => (date ? new Date(date).toLocaleDateString('ar-SA') : 'N/A'),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={3}>تقرير المقالات</Title>
        <PrintButton />
      </div>
      <Card title="تقرير المقالات">
        <div>
          <Row gutter={16} style={{ marginBottom: 16 }} className="no-print">
            <Col>
              <Select
                placeholder="اختر القسم"
                style={{ width: 200 }}
                onChange={(value) => handleFilterChange('sectionId', value)}
                allowClear
              >
                {sections.map((section) => (
                  <Option key={section.id} value={section.id}>
                    {section.name}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col>
              <Select
                placeholder="اختر المؤلف"
                style={{ width: 200 }}
                onChange={(value) => handleFilterChange('userId', value)}
                allowClear
              >
                {users.map((user) => (
                  <Option key={user.id} value={user.id}>
                    {user.username}
                  </Option>
                ))}
              </Select>
            </Col>
            <Col>
              <Button type="primary" onClick={handleSearch}>
                بحث
              </Button>
            </Col>
          </Row>
          <Table
            dataSource={articles}
            columns={columns}
            rowKey="id"
            loading={loading}
            scroll={{ x: true }}
          />
        </div>
      </Card>
    </div>
  );
};

export default ArticlesReport;